import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlockSortDescending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"block-sort-descending"} maskId="square-filled-radius-0-stroke-1-IconBlockSortDescending"><path d="M11 3H3V11H11V3Z" fill="currentColor"/><path d="M22.3535 13.3535L21.6465 12.6465L18 16.293V6H17V16.293L13.3535 12.6465L12.6465 13.3535L17.5 18.207L22.3535 13.3535Z" fill="currentColor"/><path d="M11 13H3V21H11V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBlockSortDescending;
